import firebase from "firebase/app";
import "firebase/messaging";
import Auth from "@/services/Auth";

const firebaseConfig = {
  apiKey: "AIzaSyCotT5JvbM9pimkVbsb7JEfB3EKTzlGJpY",
  authDomain: "rcpaylink-live.firebaseapp.com",
  projectId: "rcpaylink-live",
  storageBucket: "rcpaylink-live.firebasestorage.app",
  messagingSenderId: "99948666809",
  appId: "1:99948666809:web:640f614986f68cc63ee068",
  measurementId: "G-8F1B1CD52M"
};

const vapidKey = "BFGJus1HsB2ZjWgQnkjxIEJIBzrb44FHyldXwXPS4rNzZ_ZBBVjBb9CDq03HfU3-RysIwckuwnkzo2MItxuiKjU";
const version = process.env.VUE_APP_NOCACHE_VERSION;

let messaging = null;

// Inisialisasi Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Cek apakah messaging disupport di browser ini
function isFirebaseMessagingSupported() {
  return (
    typeof window !== "undefined" &&
    "Notification" in window &&
    "serviceWorker" in navigator &&
    firebase.messaging.isSupported()
  );
}

// Inisialisasi messaging jika didukung
if (isFirebaseMessagingSupported()) {
  messaging = firebase.messaging();
}

const registerServiceWorker = async () => {
  if (!isFirebaseMessagingSupported()) {
    console.warn("📵 Firebase Messaging not supported on this browser");
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js?v=" + version);
    messaging.useServiceWorker(registration);
    await navigator.serviceWorker.ready;
    console.log("✅ Service Worker Ready");
    return registration;
  } catch (error) {
    console.error("❌ Failed to register service worker:", error);
    return null;
  }
};

const getTokenAndSave = async () => {
  if (!isFirebaseMessagingSupported()) {
    console.warn("⚠️ FCM not supported, skipping token request");
    return;
  }

  try {
    const registration = await registerServiceWorker();
    if (!registration) return;

    const currentToken = await messaging.getToken({
      vapidKey,
      serviceWorkerRegistration: registration
    });

    if (currentToken) {
      console.log("✅ Token FCM:", currentToken);
      const response = await Auth.updateToken({ fcm_token: currentToken, device: "web" });

      if (response.status === 200 && response.data.success) {
        console.log("✅ Token updated to backend");
        localStorage.setItem("notification_token", currentToken);
      } else {
        console.error("❌ Failed update token:", response.data.message);
      }
    } else {
      console.warn("⚠️ Token not available.");
    }
  } catch (error) {
    console.error("❌ Error getting token:", error);
  }
};

const initializeFirebase = () => {
  if (!isFirebaseMessagingSupported()) return;

  messaging.onTokenRefresh(async () => {
    try {
      console.log("🔁 Token expired, refreshing...");
      await getTokenAndSave();
    } catch (err) {
      console.error("❌ Failed to refresh token:", err);
    }
  });
};

export {
  messaging,
  initializeFirebase,
  getTokenAndSave,
  isFirebaseMessagingSupported
};
